// ── Broken Hearts: a rose-velvet table with a gilded rim and a heart
//    filigree burned into the cloth. ──

import Table3D from './Table3D';

const Filigree = () => (
  <svg viewBox="0 0 400 260" preserveAspectRatio="none" style={{ width: '100%', height: '100%', opacity: 0.9 }}>
    <defs>
      <linearGradient id="bh-gild" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#ffd9a8" />
        <stop offset="50%" stopColor="#ffb3d1" />
        <stop offset="100%" stopColor="#ffd9a8" />
      </linearGradient>
    </defs>

    {/* Fascia alta: due cuori e un tralcio */}
    <g opacity="0.7">
      <path d="M20 20 Q80 6 140 20 T260 20 Q320 6 380 20" fill="none" stroke="url(#bh-gild)" strokeWidth="1.4" />
      {[110, 200, 290].map((x, i) => (
        <path key={i}
          d={`M${x} 26 L${x - 8} 16 Q${x - 12} 8 ${x - 5} 7 Q${x} 7 ${x} 12 Q${x} 7 ${x + 5} 7 Q${x + 12} 8 ${x + 8} 16 Z`}
          fill="#ffb3d1" opacity={i === 1 ? 0.9 : 0.55} />
      ))}
    </g>

    {/* Centro: rosa dei venti a petali */}
    <g transform="translate(200 132)" opacity="0.3">
      {Array.from({ length: 12 }, (_, i) => (
        <ellipse key={i} rx="9" ry="34" fill="none" stroke="#ffc9de" strokeWidth="0.8"
          transform={`rotate(${i * 30})`} />
      ))}
      <circle r="8" fill="none" stroke="#ffd9a8" strokeWidth="1.2" />
    </g>

    {/* Fascia bassa: il tralcio spinato e i semi */}
    <g opacity="0.75">
      <path d="M18 240 Q100 224 200 240 T382 240" fill="none" stroke="url(#bh-gild)" strokeWidth="1.4" />
      {[60, 140, 260, 340].map((x, i) => (
        <path key={i} d={`M${x} 240 l-5 -9 l5 3 l5 -3 z`} fill="#ffd9a8" opacity="0.7" />
      ))}
      <text x="200" y="254" textAnchor="middle" fontSize="9" letterSpacing="5"
        fill="#ffc9de" fontFamily="'Cinzel',serif" opacity="0.75">RESTA UN CUORE</text>
    </g>
  </svg>
);

const BhTable = ({ children, mobile = false, active = false }) => (
  <Table3D
    mobile={mobile}
    active={active}
    grain={98}
    surface={{ top: '#8e2350', mid: '#5c1234', low: '#7a1c44', deep: '#3d0c22' }}
    trim={{
      rim: 'rgba(255,205,150,0.85)', rivet: '#ffd9a8', ink: '#5c1234',
      accent: '#ffb3d1', glow: 'rgba(255,150,195,0.3)',
    }}
    inlay={<Filigree />}
  >
    {children}
  </Table3D>
);

export default BhTable;
